import React from 'react';
import { Button } from './ui/Button';
import { Check } from 'lucide-react';
const tiers = [{
  name: 'RECON',
  price: '749',
  currency: 'zł',
  period: '/mo',
  description: 'Essential surveillance for small teams.',
  features: ['Basic monitoring', '5 Competitors tracked', 'Weekly intelligence reports', 'Market news alerts', 'Email support'],
  cta: 'Start Recon',
  variant: 'secondary' as const
}, {
  name: 'TACTICAL',
  price: '1,899',
  currency: 'zł',
  period: '/mo',
  description: 'Advanced analytics for growing operations.',
  features: ['Advanced analytics suite', '15 Competitors tracked', 'Daily intelligence reports', 'API Access', 'Sentiment analysis', 'Priority support'],
  cta: 'Deploy Tactical',
  variant: 'primary' as const,
  popular: true
}, {
  name: 'COMMAND',
  price: '4,299',
  currency: 'zł',
  period: '/mo',
  description: 'Full spectrum dominance for enterprises.',
  features: ['Full intelligence suite', 'Unlimited competitors', 'Real-time alerts (SMS/Slack)', 'Dedicated analyst', 'Custom integrations', 'White-label reports', '24/7 Strategic support'],
  cta: 'Contact Command',
  variant: 'secondary' as const
}];
export function Pricing() {
  return <section className="py-24 bg-[#0a1628] relative overflow-hidden" data-id="element-169">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_50%_50%,rgba(0,212,255,0.05),transparent_70%)] pointer-events-none" data-id="element-170" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-171">
        <div className="text-center mb-16" data-id="element-172">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-173">
            MISSION FUNDING
          </h2>
          <p className="text-slate-400" data-id="element-174">
            Select your operational capacity level.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto items-start" data-id="element-175">
          {tiers.map((tier, idx) => <div key={idx} className={`relative bg-[#1a2942] rounded-xl border ${tier.popular ? 'border-[#00d4ff] shadow-[0_0_30px_rgba(0,212,255,0.15)] scale-105 z-10' : 'border-slate-700'} p-8 flex flex-col h-full transition-transform duration-300 hover:-translate-y-2`} data-id="element-176">
              {tier.popular && <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-[#00d4ff] text-[#0a1628] text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wider" data-id="element-177">
                  Most Popular
                </div>}

              <div className="mb-8" data-id="element-178">
                <h3 className={`text-lg font-bold font-mono mb-2 ${tier.popular ? 'text-[#00d4ff]' : 'text-white'}`} data-id="element-179">
                  {tier.name}
                </h3>
                <div className="flex items-baseline gap-1" data-id="element-180">
                  <span className="text-4xl font-bold text-white" data-id="element-181">
                    {tier.price}
                  </span>
                  <span className="text-xl text-slate-400" data-id="element-182">
                    {tier.currency}
                  </span>
                  <span className="text-slate-500 text-sm" data-id="element-183">{tier.period}</span>
                </div>
                <p className="text-slate-400 text-sm mt-4" data-id="element-184">
                  {tier.description}
                </p>
              </div>

              <ul className="space-y-4 mb-8 flex-1" data-id="element-185">
                {tier.features.map((feature, fIdx) => <li key={fIdx} className="flex items-start gap-3 text-sm text-slate-300" data-id="element-186">
                    <Check className={`w-5 h-5 shrink-0 ${tier.popular ? 'text-[#00d4ff]' : 'text-slate-500'}`} data-id="element-187" />
                    {feature}
                  </li>)}
              </ul>

              <Button variant={tier.variant} className="w-full" data-id="element-188">
                {tier.cta}
              </Button>
            </div>)}
        </div>
      </div>
    </section>;
}